/*
 * English entry point (default language).
 *
 * index.html loads this. The page body is assembled by app.ts; this file
 * only supplies the English dictionary and the href of the other
 * language's page for the toggle.
 */
import { en } from "./i18n/en";
import { mountPage } from "./app";

mountPage(en, "/da/");
